module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dashboard_page && _vm.getProfile.role === 'teacher') ? _c('div', {
    staticClass: "w-full relative bg-white h-10 transition-colors duration-300 border-b flex items-center z-10 focus-within:border-gray-300 hover:border-primary"
  }, [_c('i', {
    staticClass: "fas fa-search absolute left-4 -translate-y-1/2 text-gray-400",
    staticStyle: {
      "top": "13px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cursor-pointer select-none flex items-center w-full pl-10 text-gray-400 h-full border-none font-manrope",
    on: {
      "click": function($event) {
        return _vm.handleOpenSearch()
      }
    }
  }, [_c('span', [_vm._v("Search by roundtables or courses...")])])]) : (_vm.dashboard_page && _vm.getProfile.role === 'student') ? _c('div', {
    staticClass: "w-full relative font-manrope px-5 bg-white h-10 border-b flex items-center z-10 focus-within:border-gray-300"
  }, [_vm._v("\n  Hello "), _c('span', {
    staticClass: "ml-1 font-bold text-gray-800"
  }, [_vm._v(_vm._s(_vm.user_name))]), _vm._v("! Here you can see your most recently used RoundTables.\n")]) : _c('div', {
    staticClass: "bg-white h-10 border-b flex items-center z-20"
  }, [_c('div', {
    staticClass: "w-full"
  }, [(_vm.my_courses_page) ? _c('h6', {
    staticClass: "w-full flex items-center justify-between px-5"
  }, [_c('div', {
    staticClass: "text-gray-800 font-manrope"
  }, [_vm._v("\n        Hello "), _c('span', {
    staticClass: "font-bold"
  }, [_vm._v(" " + _vm._s(_vm.user_name) + "!")]), _vm._v(" Here you can see a list of your courses as an\n        "), (_vm.is_teacher_mode) ? _c('span', [_vm._v("instructor")]) : _c('span', [_vm._v("participant")]), _vm._v(".\n      ")])]) : (_vm.profile_page) ? _c('div', {
    staticClass: "px-5"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3 cursor-default"
  }, [_c('span', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.user_name))]), _vm._v(" "), _c('span', {
    staticClass: "text-xs text-gray-400 font-poppins"
  }, [_vm._v(_vm._s(_vm.userProfile.email))])]), _vm._v(" "), (_vm.userProfile.provider === 'google') ? _c('img', {
    staticClass: "w-3 h-3 ml-2 inline-block",
    attrs: {
      "src": "/static/logos/googleLogo.svg",
      "alt": "Google"
    }
  }) : (_vm.userProfile.provider === 'windowslive') ? _c('img', {
    staticClass: "w-3 h-3 ml-2 inline-block",
    attrs: {
      "src": "/static/logos/msLogo.svg",
      "alt": "Microsoft"
    }
  }) : _vm._e()]) : (_vm.admin_portal_page) ? _c('div', {
    staticClass: "flex justify-between w-full px-5"
  }, [(_vm.getProfile.role === 'admin') ? _c('div', {
    staticClass: "flex justify-between w-full"
  }, [_c('span', {
    staticClass: "font-bold"
  }, [_vm._v(" " + _vm._s(_vm.school.name))]), _vm._v(" "), (_vm.getProfile.role === 'admin') ? _c('button', {
    staticClass: "text-xl cursor-pointer hover:text-gray-800",
    on: {
      "click": _vm.signOutParlay
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  })]) : _vm._e()]) : _c('span', {
    staticClass: "font-bold"
  }, [_vm._v(" " + _vm._s(_vm.userProfile.school.name))])]) : (_vm.support_PD_page) ? _c('div', {
    staticClass: "px-5"
  }, [_c('span', {
    staticClass: "font-bold"
  }, [_vm._v("Support & PD")])]) : _c('div', {
    staticClass: "flex justify-between w-full items-center pl-5 pr-2"
  }, [(_vm.changeHeader) ? _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('div', {
    staticClass: "text-sm text-gray-800 font-bold font-manrope"
  }, [(_vm.$route.name === 'course.student-reports.summary' || _vm.$route.name === 'course.student-reports.discussion') ? _c('div', [(_vm.getProfile.is_paid) ? _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('img', {
    staticClass: "w-5 h-5 rounded-full",
    attrs: {
      "src": _vm.getUserById.avatar_url
    }
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.getUserById.name))])]) : _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('img', {
    staticClass: "w-5 h-5 rounded-full",
    attrs: {
      "src": "https://parlay-api.herokuapp.com/api/files/1599763924317-Screen Shot 2020-09-10 at 2.51.47 PM.png"
    }
  }), _vm._v(" "), _c('h6', [_vm._v("Angela Ortiz")])])]) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.rt_title))])]), _vm._v(" "), (_vm.width < 1300 && _vm.rt_title.length > 25) ? _c('span', {
    staticClass: "cursor-pointer text-xs",
    attrs: {
      "title": _vm.rt_title
    }
  }, [_vm._v("...")]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: ("/classes/" + _vm.courseId)
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-2 truncate"
  }, [_c('span', {
    staticClass: "text-xs text-gray-800 hover:underline font-poppins"
  }, [_vm._v(" " + _vm._s(_vm.courseTitle))])])])], 1) : _c('div', {
    staticClass: "flex items-center justify-between space-x-3 truncate"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: ("/classes/" + _vm.courseId)
      }
    }
  }, [_c('span', {
    staticClass: "text-sm font-bold font-manrope text-gray-800",
    class: _vm.$route.name !== 'course.index' ? 'hover:underline cursor-pointer' : 'cursor-default'
  }, [_vm._v("\n            " + _vm._s(_vm.courseTitle) + "\n          ")])]), _vm._v(" "), _c('span', {
    staticClass: "text-xs cursor-default font-poppins font-light"
  }, [_vm._v(" " + _vm._s(_vm.sections) + " ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center text-xs space-x-1 text-gray-700"
  }, [_c('div', [_c('button', {
    staticClass: "flex items-center space-x-2 px-3 py-0.5 cursor-pointer hover:bg-gray-100 text-gray-700 hover:text-gray-800 rounded-full",
    on: {
      "click": function($event) {
        return _vm.openCloseCourseChat()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-comments text-base relative"
  }, [(_vm.message_notifications > 0) ? _c('div', {
    staticClass: "absolute top-0 right-0 h-2 w-2 rounded-full bg-pinky"
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "font-poppins font-medium"
  }, [_vm._v("Chat")])])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "flex items-center space-x-2 px-3 py-0.5 hover:bg-gray-100 text-gray-700 hover:text-gray-800 cursor-pointer rounded-full",
    class: _vm.students_report_page ? 'text-primary-dark bg-gray-100' : 'text-gray-700',
    on: {
      "click": _vm.navigateToStudentReports
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-chart-bar text-base"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-medium font-poppins"
  }, [_vm._v("Reports")])])]), _vm._v(" "), _c('div', [(_vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "flex items-center space-x-2 cursor-pointer px-3 py-0.5 hover:bg-gray-100 text-gray-700 hover:text-gray-800 rounded-full",
    class: _vm.course_settings_page ? 'text-gray-800 bg-gray-100' : 'text-gray-800',
    on: {
      "click": _vm.navigateToCourseSettings
    }
  }, [_c('i', {
    staticClass: "text-base fas fa-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins font-medium"
  }, [_vm._v("Settings")])]) : _vm._e()])])]), _vm._v(" "), (_vm.show_course_chat) ? _c('div', {
    staticClass: "px-5"
  }, [_c('ChatBox', {
    on: {
      "message_notifications_val": _vm.updateUnreadMessages,
      "close": _vm.openCloseCourseChat
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-ffc4fba8!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/navbar/theHeader.vue
// module id = 922
// module chunks = 61